import {createContext, useContext, useState, ReactNode, useEffect} from "react";

interface StepContextProps {
  currentStep: number;
  setCurrentStep: (step: number) => void;
}

const StepContext = createContext<StepContextProps | undefined>(undefined);

const StepProvider = ({children}: { children: ReactNode }) => {
  const [currentStep, setCurrentStep] = useState<number>(() => {
    const savedStep = localStorage.getItem("currentStep");
    return savedStep ? parseInt(savedStep, 10) : 1;
  });

  useEffect(() => {
    localStorage.setItem("currentStep", currentStep.toString());
  }, [currentStep]);

  return (
      <StepContext.Provider value={{currentStep, setCurrentStep}}>
        {children}
      </StepContext.Provider>
  );
};

const useStep = (): StepContextProps => {
  const context = useContext(StepContext);
  if (!context) {
    throw new Error("useStep must be used within a StepProvider");
  }
  return context;
};

export {StepProvider, useStep};
